import React from 'react';
import PropTypes from 'prop-types';

import { RadioInput } from 'uikit/inputs';

const FormFieldRadioInput = ({
  fieldId,
  fieldKey,
  schema = { label: '', options: [] },
  updateField,
  value = '',
}) => (
  <RadioInput
    fieldId={fieldId}
    fieldKey={fieldKey}
    options={schema.options}
    labelPosition="right"
    label={schema.label}
    value={value}
    updateField={updateField}
    isDisabled={schema.isDisabled}
    isHidden={schema.isHidden}
    isStacked={schema.isStacked}
  />
);

FormFieldRadioInput.propTypes = {
  fieldId: PropTypes.string.isRequired,
  fieldKey: PropTypes.string.isRequired,
  value: PropTypes.string,
  schema: PropTypes.shape({
    label: PropTypes.string,
    isDisabled: PropTypes.bool,
    options: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string.isRequired,
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
        isDisabled: PropTypes.bool,
      }),
    ),
  }),
  updateField: PropTypes.func.isRequired,
};

export default FormFieldRadioInput;
